import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';
import logo from '../../assets/images/logo.svg';
import backIcon from '../../assets/svgs/back-icon.svg';
import { cn } from '../../utils/cn';

export type HeaderProps = {
    showBack?: boolean;
    onBack?: () => void;
    backLabel?: string;
    className?: string;
};

export default function Header({ showBack = false, onBack, backLabel, className }: HeaderProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const label = String(backLabel ?? t('registrationTopBarBack'));

    const handleBack = () => {
        if (typeof onBack === 'function') {
            onBack();
            return;
        }
        navigate(-1);
    };

    return (
        <header className={cn('flex items-center justify-between py-4 md:px-0 md:py-0', className)}>
            {showBack && (
                <button
                    className="flex items-center gap-0.5 text-secondary-base text-xs font-semibold"
                    onClick={handleBack}
                >
                    <img src={backIcon} alt="back" className="w-6 h-6" />
                    <span className="hidden lg:inline-block">{label}</span>
                </button>
            )}
            <Link to="/" title="Home" className="inline-block">
                <img src={logo} alt="Ardshinbank" className="h-8 w-36 lg:h-11 lg:w-48" />
            </Link>
            <LanguageSwitcher withGlobe className="!ms-0 shrink-0" />
        </header>
    );
}
